import React from 'react';
import Proximamente from '../components/Proximamente';
import Navbar from '../components/Navbar'

const Reservas = () => {
    return (
        <div>
            <Navbar />
            <Proximamente />
        </div>
    );
};

export default Reservas;